export var getDocument = function getDocument() {
  if (typeof window === 'undefined') {
    return;
  }
  if (typeof window.document === 'undefined') {
    return;
  }
  return window.document;
};